import { render, staticRenderFns } from "./EditAddressPanel.vue?vue&type=template&id=18dc3654&scoped=true"
import script from "./EditAddressPanel.vue?vue&type=script&lang=js"
export * from "./EditAddressPanel.vue?vue&type=script&lang=js"
import style0 from "./EditAddressPanel.vue?vue&type=style&index=0&id=18dc3654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc3654",
  null
  
)

export default component.exports